import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {VoucherDomainsService} from './services/voucher-domains.service';

import {Domain} from 'classes/domain';

@Component({
  selector: 'voucher-domains',
  templateUrl: './voucher-domains.component.html',
  styleUrls: ['./voucher-domains.component.css'],
})
export class VoucherDomainsComponent implements OnInit {

  public allDomains: Array<Domain> = [];
  public filteredDomains: Array<Domain>;
  public fieldsToSearch: Array<Array<string>> = [];
  public newDomainName: string;
  public searchTerm: string;
  public currentPage: Event;

  constructor(private voucherDomainsService: VoucherDomainsService) { }

  public ngOnInit(): void {
    this.getAllDomains();
  }

  private getAllDomains(): void {
    this.voucherDomainsService.getAllDomains()
      .subscribe((allDomains: Array<Domain>) => {
        this.allDomains = allDomains;
        this.filteredDomains = allDomains;
        this.prepareFieldsToSearch();
      });
  }

  public saveNewDomain(): void {
    this.voucherDomainsService.saveNewDomain(this.newDomainName)
      .subscribe((savedDomain: Domain) => {
        this.getAllDomains();
      });
  }

  private updateDomain(id: number, name: string): void {
    this.voucherDomainsService.updateDomain(id, name)
      .subscribe((updatedDomain: Domain) => {
        this.getAllDomains();
      });
  }

  private deleteDomain(id: number): void {
    this.voucherDomainsService.deleteDomain(id)
      .subscribe((isDeleted: boolean) => {
        this.getAllDomains();
      });
  }

  public filterDomains(eventDomains: Array<Domain>): void {
    this.filteredDomains = eventDomains;
  }

  private prepareFieldsToSearch(): void {
    this.allDomains.forEach((domain: Domain) => {
      this.fieldsToSearch.push([
        domain.name.toLowerCase(),
      ]);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-domains/voucher-domains.component.ts